import { render, staticRenderFns } from "./view-detail.vue?vue&type=template&id=437c9968&"
import script from "./view-detail.vue?vue&type=script&lang=js&"
export * from "./view-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports